import { z } from 'zod';
import { organizationBranding } from '../../client-config/organization/branding';
import { useOrganization } from './useOrganization';

/**
 * `Organization.uiSettings` is `unknown` in the API client, so the flags the
 * splitting screen reads are parsed here, narrowly and leniently.
 */
const organizationFeaturesSchema = z
  .object({
    features: z
      .object({
        disable_download_original: z.boolean().optional().catch(false),
      })
      .passthrough()
      .optional()
      .catch({}),
  })
  .passthrough()
  .catch({});

export const useIsTrial = (): boolean => {
  const { data: organization } = useOrganization();

  return organization?.isTrial ?? false;
};

export const useDisableDownloadOriginal = (): boolean => {
  const { data: organization } = useOrganization();

  if (!organization) return false;

  return (
    organizationFeaturesSchema.parse(organization.uiSettings).features
      ?.disable_download_original ?? false
  );
};

export const useHideArticleLinks = (): boolean => {
  const { data: organization } = useOrganization();

  if (!organization) return false;

  return !organizationBranding.showExternalResources(organization.uiSettings);
};
